import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import { imageUrlFor } from '../../lib/image-url';
import { buildImageObj } from '../../lib/helpers';
import { isBrowser } from '../../utils/isBrowser';

function SEO({ description, lang, meta, keywords, title, image = '/assets/images/tab_header_icon_black_117x117.png' }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription = description || (data.site && data.site.description) || '';
        const siteTitle = (data.site && data.site.title) || '';
        const siteAuthor = (data.site && data.site.author && data.site.author.name) || '';
        const metaImagePath = 'assets/images/tab_header_icon_black_117x117.png';
        const siteOrigin = isBrowser ? window.location.href : '';

        return (
          <Helmet
            htmlAttributes={{ lang: 'he' }}
            title={title}
            titleTemplate={title === siteTitle ? '%s' : `%s | ${siteTitle}`}
            meta={[
              {
                property: 'og:locale',
                content: 'he',
              },
              {
                property: 'og:type',
                content: 'website',
              },
              {
                property: 'og:url',
                content: `${siteOrigin}`,
              },
              {
                property: 'og:title',
                content: 'אולטרה פיננסים',
              },
              {
                property: 'og:description',
                content: 'בנקאות מימון, בלי בנק',
              },
              {
                name: 'description',
                content: metaDescription,
              },
              {
                property: 'og:image',
                content: `${siteOrigin}${metaImagePath}`,
              },
              {
                property: 'og:logo',
                content: `${siteOrigin}${metaImagePath}`,
              },
              {
                name: 'twitter:card',
                content: 'summary',
              },
              {
                name: 'twitter:creator',
                content: siteAuthor,
              },
              {
                name: 'twitter:title',
                content: title,
              },
              {
                name: 'twitter:description',
                content: metaDescription,
              },
            ]
              .concat(
                keywords && keywords.length > 0
                  ? {
                      name: 'keywords',
                      content: keywords.join(', '),
                    }
                  : []
              )
              .concat(meta)}
          />
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  keywords: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site: sanitySiteSettings(_id: { eq: "siteSettings" }) {
      title
      description
      keywords
      author {
        name
      }
    }
  }
`;
